export default __webpack_public_path__ + "static/media/bluintouch-logo.13d15584.svg";